import { InfoApiService } from "../api/InfoService";
import logger from "../utils/logger";
import { IResult } from "../models/results/result.interface";
import {
  ApiReportTypesToReportTypes,
  ReportTypes,
} from "../models/reports.interface";

const getAPIVersion = async (): Promise<string | null> => {
  logger.info(getAPIVersion.name, "Getting API version");

  try {
    const { response: resp, error } = await InfoApiService.infoGetApiVersion();

    if (error || !resp) {
      logger.error(getAPIVersion.name, "Invalid API response", {
        resp,
        error,
      });
      return null;
    }

    return resp;
  } catch (error) {
    logger.error(getAPIVersion.name, "Error Getting API version.", error);
    return null;
  }
};

const getReportTypes = async (): Promise<IResult<ReportTypes[]>> => {
  logger.info(getReportTypes.name, `Getting report type...`);
  try {
    const {
      response: resp,
      error,
    } = await InfoApiService.infoGetUserReportTypes();

    if (error || !resp) {
      logger.error(getReportTypes.name, "Invalid API response", {
        resp,
        error,
      });
      return {
        success: false,
        message: error?.errorMessage,
        errorCode: error?.errorCode?.toString(),
      };
    }

    const convertedReportTypes: ReportTypes[] = [];
    resp.forEach((i) => {
      const mappedType =
        ApiReportTypesToReportTypes[
          i as keyof typeof ApiReportTypesToReportTypes
        ];
      if (!mappedType) return;

      convertedReportTypes.push((mappedType as unknown) as ReportTypes);
    });

    return {
      success: true,
      data: convertedReportTypes,
    };
  } catch (error) {
    logger.error(getReportTypes.name, "Error getting report type.", error);
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};

const infoService = {
  getAPIVersion,
  getReportTypes,
};

export default infoService;
